import React from 'react';
import Avatar from '@mui/material/Avatar';

const ChipLabel = (props) => {
  const { avatar, textArray, avatarOrder = 'left', listKey } = props || {
    avatar: '-',
    textArray: []
  };

  return (
    <div style={{ display: 'grid' }} key={listKey}>
      {textArray.map((line, idx) =>
        !line ? (
          <div key={`empty-${idx}`} style={{ height: '6px' }} />
        ) : (
          <div key={`line-${idx}`} style={{ display: 'flex' }}>
            <Avatar
              className="MuiAvatar-root MuiAvatar-circle MuiChip-avatar MuiChip-avatarColorPrimary MuiAvatar-colorDefault"
              style={{
                marginLeft: '0',
                marginRight: '4px',
                marginTop: '4px',
                marginBottom: '4px',
                backgroundColor:
                  avatarOrder === 'left' ? '#1976d2' : '#F5F5F5',
                color: avatarOrder === 'left' ? '#fafafa' : '#000000',
                visibility: idx !== 0 ? 'hidden' : 'visible'
              }}
            >
              {avatar}
            </Avatar>
            <p
              style={{
                paddingLeft: '8px',
                paddingRight: '8px',
                marginLeft: '0',
                marginRight: '4px',
                marginTop: '4px',
                marginBottom: '4px',
                whiteSpace: 'break-spaces'
              }}
            >
              {line}
            </p>
          </div>
        )
      )}
    </div>
  );
};

export default ChipLabel;